import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllInvoiceToDetails extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    invoiceLinkWith: '',
    universities: [],
    channelPartners:[]
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({exportParams: params})
      let data = await Request.getInvoiceToDetails({
        ...params,
        regExFilters: []
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }
  handleSubmit = e => {
    const { form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateInvoiceToDetails(values)
        } else {
          x = await Request.addInvoiceToDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Invoice To Updated Successfully`
              : 'Invoice To Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteInvoiceToDetails = async data => {
    this.setState({loading: true})
    await Request.deleteInvoiceToDetails(data)

    this.setState({loading: false})

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  loadUniversity = async ()=> {
    Request.loadSimpleUniversities({sort: {instituteName: 1}})
      .then(resp => {
        resp.arr = resp.arr.reduce((temp, vv) => {
            temp.push({_id: vv._id, display: vv.universityInstitutionName})
            return temp
        }, [])

        this.setState({'universities': resp.arr});
      })
      .catch(err => {
          console.log(err)
      })
  }
  loadChannelPartner = async ()=> {
    Request.loadChannelPartners({
      results: 10000,
      count: 1000
    })
      .then(resp => {
        resp.data = resp.data.reduce((temp, vv) => {
          temp.push({_id: vv._id, display: vv.channelPartnerName})
          return temp
        }, [])

        this.setState({'channelPartners': resp.data});
      })
      .catch(err => {
          console.log(err)
      })
  }
  setInvoiceToDetailsData(invoiceToId) {
    if (invoiceToId) {
      Request.financeInvoiceToDetailsByID({id: invoiceToId}).then(
        ({doc, error, message}) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1',
            })
            
            this.props.form.setFieldsValue({
              invoiceToName: doc.invoiceToName,
              invoiceAddress: doc.invoiceAddress,
              kindAttention: doc.kindAttention,
              invoiceToEmail: doc.invoiceToEmail,
              invoiceToPhone: doc.invoiceToPhone,
              invoiceToCategory: doc.invoiceToCategory,
              invoiceToStatus: doc.invoiceToStatus,
              invoiceLinkWith: doc.invoiceLinkWith,
              universityId: doc.universityId,
              channelPartnerId: doc.channelPartnerId,
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    } else {
      notification.error({
        message: 'Error Getting Data'
      })
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
    await this.loadUniversity();
    await this.loadChannelPartner();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const { id, universities, channelPartners} = this.state;

    const inputTypes = {
      fields: [
        {
          label: 'Invoice To Name',
          key: 'invoiceToName',
          required: true
        },
        {
          label: 'Invoice Address',
          key: 'invoiceAddress',
          required: true
        },
        {
          label: 'Kind Attention',
          key: 'kindAttention',
          required: true
        },
        {
          label: 'Invoice Email',
          key: 'invoiceToEmail',
          required: true,
          type: 'email'
        },
        {
          label: 'Invoice Phone',
          key: 'invoiceToPhone',
          required: true
        },
        {
          label: 'Invoice Category',
          key: 'invoiceToCategory',
          required: true
        },
        {
          label: 'Status',
          key: 'invoiceToStatus',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'Active', 'Inactive'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({
              invoiceToStatus: v
            })
          }
        },
        {
          label: 'Invoice Linked With',
          key: 'invoiceLinkWith',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: [
            'University', 'Channel Partner'
          ],
          onChange: v => {
            this.setState({invoiceLinkWith: v});
            this.props.form.setFieldsValue({
              invoiceLinkWith: v
            })
          }
        },
        {
          label: 'University',
          key: 'universityId',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: universities,
          hidden: (this.state.invoiceLinkWith != 'University'),
          onChange: v => {
            this.setState({universityId: v});
            this.props.form.setFieldsValue({
              universityId: v
            })
          }
        },
        {
          label: 'Channel Partner',
          key: 'channelPartnerId',
          type: 'select',
          required: true,
          showSearch: true,
          disabled: false,
          options: channelPartners,
          hidden: (this.state.invoiceLinkWith != 'Channel Partner'),
          onChange: v => {
            this.setState({channelPartnerId: v});
            this.props.form.setFieldsValue({
              channelPartnerId: v
            })
          }
        }
      ]
    };

    const columns = [
      {
        title: 'Invoice To Name',
        key: 'invoiceToName',
      },
      {
        title: 'Invoice Address',
        key: 'invoiceAddress',
      },
      {
        title: 'Kind Attention',
        key: 'kindAttention'
      },
      {
        title: 'Invoice Email',
        key: 'invoiceToEmail'
      },
      {
        title: 'Invoice Phone',
        key: 'invoiceToPhone'
      },
      {
        title: 'Invoice Category',
        key: 'invoiceToCategory'
      },
      {
        title: 'Status',
        key: 'invoiceToStatus'
      },
      {
        title:'University Name',
        key:'universityInstitutionName',
      },
      {
        title: 'Updated By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'financeInvoiceTo.edit'}>
              <Tooltip title="Edit Commission">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setInvoiceToDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'financeInvoiceTo.delete'}>
              <Tooltip title="Delete Commission">
                <Popconfirm
                  title="Are you sure delete this Detail?"
                  onConfirm={() => {
                    this.deleteInvoiceToDetails({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Invoice Recipients `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Details`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Invoice To'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllInvoiceToDetails
